/* global Plotly */

import React, { Component } from 'react'

import numeral from 'numeral'
import Tooltip from 'react-simple-tooltip'
// import FechaActualizacionLabel from '../FechaActualizacionLabel'
import { withStyles } from '@material-ui/core/styles'

import Plot from 'react-plotly.js';


const styles = theme => ({
  container: {
    minHeight: 450,
    [theme.breakpoints.down('xs')]: {
      overflowX: 'auto'
    }
  },
  chart: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      width: 600
    }
  }
})

class CompletitudCalidadInstalaciones extends Component {
  constructor (props) {
    super(props)
    this.state = {
      dataset: null,
      isPending: true,
      ymargin: 100,
      tooltip: {
        show: false,
        content: '',
        position: [0, 0]
      },
      revision: 0,
      fechaActualizacion: null
    }
    this.typeProps = {
      color: {
        'completitud': '#66C5CB',
        'calidad': '#668CCB',
        'validado': '#00c172',
        'enUso': '#f5b245',
        'rechazado': '#ff4e41',
        'noRevisado': 'white',
      },
      title: {
        'completitud': 'Completitud',
        'calidad': 'Calidad'
      }
    }
  }

  componentDidMount () {
    if (!this.props.dataset.isPending && this.props.dataset.data) {
      const {type} = this.props
      const data = this.props.dataset.data
      this.setChartData(type, data)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.dataset.isPending !== nextProps.dataset.isPending &&
    !nextProps.dataset.isPending && nextProps.dataset.data) {
      const {type} = this.props
      const data = nextProps.dataset.data
      this.setChartData(type, data)
    }
  }

  setChartData (type, data) {
    let barData = {
      x: [],
      y: [],
      text: []
    }

    
    data.forEach((d) => {
        console.log("CD", d)
      barData.text.push(`${numeral(d[type]).format('0.00')}%`)
      barData.x.push(d[type] * 0.01)
      barData.y.push(d.tipo_instalacion)
    })


    let longestLabel = barData.y.reduce((a, b) => a.length > b.length ? a : b, '')
    let letterWidth = 6
    let ymargin = longestLabel.length * letterWidth

    this.setState({
      dataset: {
        barData: barData
      },
      isPending: false,
      ymargin: ymargin,
      fechaActualizacion: data[0].fecha_actualizacion
    })
  }

  plotHover (e) {
    const {type} = this.props
    let tooltip = this.state.tooltip
    tooltip.show = true
    tooltip.position = [e.event.pageX - e.event.movementX, e.event.pageY]
    console.log("Debug chart tooltip e.points[0].y", e.points[0].y, "Debug chart tooltip e.points[0].text",e.points[0].text)

    tooltip.content = <div>
      <b>{e.points[0].y}</b><hr />
      <span>{type}: {e.points[0].text}</span>
    </div>
    this.setState({tooltip})
  }

  plotUnhover () {
    let tooltip = this.state.tooltip
    tooltip.show = false
    this.setState({tooltip})
  }

  render () {
    const {classes, type} = this.props
    const {dataset, isPending, ymargin, fechaActualizacion} = this.state
    console.log("Debug Bar data", dataset)
    if (isPending){
      return <div>Cargando...</div>
    }

    const graphData = [
      {
        type: 'bar',
        x: dataset.barData.x,
        y: dataset.barData.y,
        text: dataset.barData.text,
        textposition: 'outside',
        hoverinfo: 'none',
        orientation: 'h',
        cliponaxis: false,
        marker: {
          color: this.typeProps.color[type]
        }
      }
    ]

    const height = (28.5 * this.props.dataset.data.length) + 200
    console.log("Debug Height",  height)

    const layout = {
      title: `${this.typeProps.title[type]} por Tipo de Instalación`,
      titlefont: {
        family: 'DINRegular',
        siz: 26
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
      font: {
        color: '#000'
      },
      height: height,
      xaxis: {
        showgrid: false,
        linecolor: '#97979C',
        range: [0, 1],
        rangemode: 'nonnegative',
        tickformat: '.0%',
        tickfont: {
        size: 10
        },
        fixedrange: true
      },
      yaxis: {
        showgrid: false,
        linecolor: '#97979C',
        tickfont: {
          size: 10
        },
        autorange: 'reversed',
        fixedrange: true
      },
      margin: {
        l: ymargin
      }
      // hovermode:'closest',
      // dragmode: 'select'
    }

    return (
      <div className={classes.container} >
        {(dataset && !isPending)
          ? 
            <Plot
              divId={`${type}-instalaciones-chart`}
              className={classes.chart}
              data={graphData}
              layout={layout}
              config={{
                displayModeBar: false,
                responsive: true
              }}
              onHover={(e) => this.plotHover(e)}
              onUnhover={() => this.plotUnhover()}
              revision={this.state.revision}
            />
          : <div>Cargando...</div>
        }
        {this.state.tooltip.show &&
          <Tooltip
            className='simple-tooltip'
            background='#fff'
            border='#ccc'
            color='#333'
            radius={3}
            fontSize='12px'
            fixed
            style={{
              width: 'auto',
              position: 'absolute',
              left: this.state.tooltip.position[0],
              top: this.state.tooltip.position[1]
            }}
            content={this.state.tooltip.content}
          />
        }
        {/* {!isPending && fechaActualizacion && <FechaActualizacionLabel date={fechaActualizacion}/>} */}
      </div>
    )
  }
}

export default withStyles(styles)(CompletitudCalidadInstalaciones)
